import SectionHeading from "./SectionHeading";
import { useI18n } from "@/i18n";

const ICON = (slug) => `https://cdn.simpleicons.org/${slug}/ffffff`;

// Brand names are intentionally kept as proper-noun product names — these don't translate.
const BRANDS = [
  { name: "Apple", slug: "apple" },
  { name: "Samsung", slug: "samsung" },
  { name: "Xiaomi", slug: "xiaomi" },
  { name: "Honor", slug: "honor" },
  { name: "Oppo", slug: "oppo" },
  { name: "Vivo", slug: "vivo" },
  { name: "Huawei", slug: "huawei" },
];

export default function Brands() {
  const { t } = useI18n();
  const list = [...BRANDS, { name: t("brands.other"), slug: null }];
  return (
    <section id="brands" data-testid="brands-section" className="relative py-24 md:py-32">
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          testId="brands-heading"
          eyebrow={t("brands.eyebrow")}
          title={<>
            {t("brands.title_a")}{" "}
            <span className="text-gradient-brand">{t("brands.title_b")}</span>
            {t("brands.title_dot")}
          </>}
          subtitle={t("brands.subtitle")}
          align="center"
        />

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {list.map((b, i) => (
            <div
              key={b.name}
              data-testid={`brand-card-${i}`}
              className="glass-card rounded-2xl py-8 px-5 flex flex-col items-center justify-center text-center gap-3 reveal min-h-[140px] group"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              {b.slug ? (
                <img
                  src={ICON(b.slug)}
                  alt={`${b.name} logo`}
                  className="h-7 md:h-8 w-auto object-contain opacity-80 group-hover:opacity-100 transition-opacity"
                  style={{ filter: "drop-shadow(0 0 18px rgba(122,92,255,0.35))" }}
                  loading="lazy"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              ) : (
                <span aria-hidden className="inline-flex items-center justify-center h-8 w-8 rounded-full border border-white/20 text-[14px] text-white/80">+</span>
              )}
              <span className="font-display text-[15px] md:text-[16px] font-semibold tracking-tight text-white">
                {b.name}
              </span>
            </div>
          ))}
        </div>

        <div data-testid="brands-disclaimer" className="mt-10 max-w-3xl mx-auto text-center text-[12.5px] leading-relaxed text-[#6F7280] reveal">
          {t("brands.disclaimer")}
        </div>
      </div>
    </section>
  );
}
